import { Images } from 'assets/images';
import { ModalWrapper } from 'admin/components/Users/styled';
import { ModalContainer } from 'admin/containers/Home/styled';
import {
  CloseIcon,
  DeleteContainer,
  AreYouSureDelete,
  ButtonWrapper,
  ButtonCancelAndDelete,
  ItemBoldText,
} from 'admin/components/SureToDeleteModal/styled';

export const ConfirmModal = ({ handleDelete, CloseModal }) => {
  const acceptDelete = (e) => {
    e.preventDefault();
    handleDelete();
  };

  return (
    <ModalContainer>
      <ModalWrapper isDeleteModal>
        <CloseIcon src={Images.adminCloseIcon} onClick={CloseModal} />
        <DeleteContainer>
          <AreYouSureDelete>
            Are your sure you want to delete <ItemBoldText>item</ItemBoldText> ?
          </AreYouSureDelete>
          <ButtonWrapper>
            <ButtonCancelAndDelete isCancel onClick={CloseModal}>
              Cancel
            </ButtonCancelAndDelete>
            <ButtonCancelAndDelete onClick={acceptDelete}>
              Delete
            </ButtonCancelAndDelete>
          </ButtonWrapper>
        </DeleteContainer>
      </ModalWrapper>
    </ModalContainer>
  );
};
